import { Component, ViewChild, EventEmitter} from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { documentoAddEditComponent } from './agregar-editar/documentoAddEdit.component';
import { DataService } from '../../utils/data.service';
import { modalComponent } from '../../utils/modal/modal.component';
import { HR_Documento } from '../../models/HR_Documento';
import { DataSourceGrid, datosGrid } from '../../utils/sourceGrid.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'my-documento',
  styleUrls: [],
  templateUrl: 'documento.component.html',
  providers: [generalService]
})

export class documentoComponent {
  public idPersonal:string;
  displayedColumns = ['acciones', 'TIPODOCUMENTO', 'DOCUMENTO', 'ORIGINALCOPIA'];
  public datosDocumentos:Array<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: DataSourceGrid | null;
  public gridDatos:any; 
  public documento: HR_Documento;
  
  constructor(private route: ActivatedRoute, private _generalService: generalService, public dialog: MatDialog, public dataService: DataService, private sanitizer:DomSanitizer) {
     this.datosDocumentos = new Array();
     this.documento = new HR_Documento();
     this.idPersonal = this.route.snapshot.paramMap.get('id');
  }

  consultarDocumentos(){
    this._generalService.metodoCall("documento/consultarDocumentos/"+this.idPersonal).subscribe(
        result => {
          this.datosDocumentos = JSON.parse(result);
          this.gridDatos = new datosGrid(this.datosDocumentos);
          this.dataSource = new DataSourceGrid(this.gridDatos, this.paginator, this.sort);
          if(this.datosDocumentos.length <= 0)
          {
            $("#documentosTable .mat-row").remove(".mat-row");
          }
        },
        error => {
          var errorMsj = <any>error;
          console.log(errorMsj);
        }
      );
  }

  ngOnInit() {
    this.consultarDocumentos();
  }

  editar(DOCUMENT_iD){
    this.dataService.id = DOCUMENT_iD;
    this.dataService.tipo = "editar";
    this.dataService.idPersonal = this.idPersonal;
    const dialogRef = this.dialog.open(documentoAddEditComponent, {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef; 
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El registro se modificó exitosamente!");
        this.consultarDocumentos();     
      }
      else if(this.dataService.mensajeAlert != "" && this.dataService.mensajeAlert != undefined){
         this.modal("alert", this.dataService.mensajeAlert);
      }
    });
  }

  agregar(){
    this.dataService.tipo = "agregar";
    this.dataService.idPersonal = this.idPersonal;
    const dialogRef = this.dialog.open(documentoAddEditComponent, {disableClose: true, width:'100%', maxWidth:'60%', panelClass: 'full-width-dialog'});
    this.dataService.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe((result) => {
      if(this.dataService.guardado){
        this._generalService.toastCall("El registro se agregó exitosamente!");
        this.consultarDocumentos();
      } 
    });
  }

  sanitize(url:string){
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  b64toBlob(b64Data, contentType, sliceSize?) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  descargar(base64, contentType, filename){
    const blob = this.b64toBlob(base64, contentType);
    const url = window.URL.createObjectURL(blob);
    const urlDescarga = document.createElement('a');
    urlDescarga.href = url;
    urlDescarga.download = filename;
    document.body.appendChild(urlDescarga);
    urlDescarga.click();
    document.body.removeChild(urlDescarga);
    window.URL.revokeObjectURL(url);
  }

  eliminarConfirm(data: any){
    this.documento.DOCUMENT_iD = data.DOCUMENT_iD;
    this.documento.FILE_ID = data.FILE_ID;
    //this.documento.loacs = sessionStorage.getItem("acslo");
    let eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {
        if(response){
            this.modal("alert", response);
        }else{
            this.consultarDocumentos();
        }
      }
    );
    this._generalService.modal(eliminarHttp, "confirm", "¿Desea eliminar el documento " + data.DOCUMENTO + "?", "documento/eliminarDocumento/", this.documento);
  }

  modal(tipo, mensaje){
    this.dataService.modal = tipo;
    this.dataService.mensaje = mensaje;
    const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
    this.dataService.dialogModal = dialogModal;
    dialogModal.afterClosed().subscribe((result) => {
        this.consultarDocumentos();
    });
  }
}

export interface UserData {
  DOCUMENT_iD:number;
  USER_NAME:string;
  EMAIL:string;
}


// WEBPACK FOOTER //
// ./src/app/personal/documentos/documento.component.ts